import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ViewTreeNode } from 'src/app/engine/models/view.tree-node';
import { StoryLabelsState } from 'src/app/story/state/labels/story.labels.state';
import { trigger, transition, useAnimation } from '@angular/animations';
import { AnimationLib } from 'src/app/shared/libraries/animations/animation-lib';

@Component({
  selector: 'app-view-label-description',
  templateUrl: './view-label-description.component.html',
  styleUrls: ['./view-label-description.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('refresh', [
      transition(':enter', [
        useAnimation(AnimationLib.slideTransition, {
          params: {
            duration: 300,
            from: 50,
            to: 0
          }
        })
      ])
    ])
  ]
})
export class ViewLabelDescriptionComponent implements OnInit {

  @Select(StoryLabelsState.getSelectedLabel)
  selectedLabel$: Observable<ViewTreeNode>;

  @Input()
  layout: 'drawer' | 'column' = 'drawer';

  constructor() { }

  ngOnInit() {
  }

}
